export default __webpack_public_path__ + "static/media/gm.2b901b6e.svg";